/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Products_Leveling_Faq_Beside_QInputs */



/**
* | output |
* | --- |
* | "Can I try it beside my old bot?" |
*
* @param {Products_Leveling_Faq_Beside_QInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const products_leveling_faq_beside_q = /** @type {((inputs?: Products_Leveling_Faq_Beside_QInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Products_Leveling_Faq_Beside_QInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Можно попробовать рядом со старым ботом?")
	return /** @type {LocalizedString} */ ("Can I try it beside my old bot?")
});